import * as React from 'react';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export const CUI_CLASSIFICATION = 'cui';
export const UNCLASSIFIED_CLASSIFICATION = 'unclassified';

export function classificationIsCui(value) {
  return value === CUI_CLASSIFICATION;
}

export default function RequestClassificationField({
  value,
  onChange,
  disabled = false,
  error = false,
  helperText = 'Select whether this request contains Controlled Unclassified Information.',
}) {
  return (
    <TextField
      select
      label="Content Classification"
      value={value}
      onChange={onChange}
      required
      fullWidth
      disabled={disabled}
      error={error}
      helperText={helperText}
    >
      <MenuItem value={UNCLASSIFIED_CLASSIFICATION}>UNCLASSIFIED</MenuItem>
      <MenuItem value={CUI_CLASSIFICATION}>CUI</MenuItem>
    </TextField>
  );
}
